// Mock data pour ETGMOUCHEL

export const companyInfo = {
  name: "ETGMOUCHEL",
  tagline: "Votre partenaire de confiance en Normandie pour tous vos besoins de levage et transport",
  description: "Entreprise spécialisée dans le grutage, le transport d'engins et le transport général basée en Normandie",
  region: "Normandie",
  phone1: "06 07 30 53 62",
  phone2: "07 68 74 80 72",
  email1: "martial.mouchel@gmail.com",
  email2: "noemouchel5@gmail.com",
};

export const services = [
  {
    id: 1,
    title: "Grutage",
    icon: "Construction",
    description: "Services de levage avec camion-grue équipé d'une flèche hydraulique. Intervention rapide pour tous vos besoins de manutention.",
    features: [
      "Camion-grue moderne et performant",
      "Flèche hydraulique articulée",
      "Intervention rapide en Normandie",
      "Respect strict des normes de sécurité"
    ],
    image: "https://customer-assets.emergentagent.com/job_manutention-express/artifacts/w4xxoii8_WhatsApp%20Image%202026-04-16%20at%2015.16.11%20%281%29.jpeg"
  },
  {
    id: 2,
    title: "Porte-Engins",
    icon: "Truck",
    description: "Transport d'équipements lourds avec notre plateau porte-engins. Solution complète pour le déplacement de vos machines.",
    features: [
      "Plateau équipé de rampes",
      "Chargement et déchargement sécurisés",
      "Transport d'engins de chantier",
      "Service fiable et professionnel"
    ],
    image: "https://customer-assets.emergentagent.com/job_manutention-express/artifacts/h28udurh_WhatsApp%20Image%202026-04-17%20at%2011.20.54.jpeg"
  },
  {
    id: 3,
    title: "Transport Général",
    icon: "Package",
    description: "Transport de matériaux et équipements avec notre véhicule polyvalent. Service adapté aux professionnels et particuliers.",
    features: [
      "Véhicule multi-usage",
      "Transport de matériaux de construction",
      "Livraison en Normandie",
      "Tarifs compétitifs"
    ],
    image: "https://customer-assets.emergentagent.com/job_manutention-express/artifacts/hp54oezu_WhatsApp%20Image%202026-04-17%20at%2011.19.16.jpeg"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Clock",
    title: "Disponibilité Rapide",
    description: "Intervention sous 24h pour répondre à vos besoins urgents"
  },
  {
    id: 2,
    icon: "DollarSign",
    title: "Tarifs Compétitifs",
    description: "Les meilleurs prix du marché sans compromis sur la qualité"
  },
  {
    id: 3,
    icon: "Shield",
    title: "Service Fiable",
    description: "Professionnalisme et sérieux garantis sur chaque intervention"
  },
  {
    id: 4,
    icon: "Settings",
    title: "Équipement Adapté",
    description: "Matériel moderne et parfaitement entretenu"
  }
];

export const testimonials = [
  {
    id: 1,
    author: "Jean-Pierre Dubois",
    company: "TP Dubois & Fils",
    role: "Directeur",
    content: "Excellent service ! L'équipe est réactive, professionnelle et les tarifs sont très compétitifs. Nous faisons appel à eux régulièrement pour nos chantiers.",
    rating: 5
  },
  {
    id: 2,
    author: "Marie Laurent",
    company: "Constructions Laurent",
    role: "Cheffe de projet",
    content: "Très satisfaite de leurs prestations. Le matériel est en excellent état et les opérateurs sont compétents. Je recommande vivement pour tous travaux de levage.",
    rating: 5
  },
  {
    id: 3,
    author: "Philippe Martin",
    company: "Travaux Publics Normandie",
    role: "Responsable logistique",
    content: "Partenaire de confiance depuis 3 ans. Toujours disponibles, même pour des interventions urgentes. Un vrai atout pour notre activité.",
    rating: 5
  }
];

export const aboutContent = {
  title: "À Propos d'ETGMOUCHEL",
  description: "Basée en Normandie, ETGMOUCHEL est une entreprise spécialisée dans le grutage, le transport d'engins (porte-engins) et le transport général. Nous intervenons rapidement sur différents types de chantiers pour répondre aux besoins des professionnels du bâtiment, des travaux publics, ainsi que des particuliers.",
  values: [
    "Service fiable, rapide et efficace",
    "Disponibilité et réactivité en toute la Normandie",
    "Équipement moderne : camion-grue polyvalent",
    "Tarifs compétitifs et transparents"
  ],
  commitment: "Notre objectif est de proposer un service professionnel qui reflète nos valeurs de sérieux et de modernité. Nous mettons l'accent sur la qualité du service afin de répondre au mieux aux besoins de nos clients, qu'ils soient professionnels ou particuliers."
};

// Mock function pour simuler l'envoi du formulaire
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Formulaire soumis (MOCK):", formData);
      // Sauvegarder dans localStorage pour simulation
      const existingContacts = JSON.parse(localStorage.getItem('contactForms') || '[]');
      existingContacts.push({
        ...formData,
        date: new Date().toISOString(),
        id: Date.now()
      });
      localStorage.setItem('contactForms', JSON.stringify(existingContacts));
      resolve({ success: true, message: "Demande envoyée avec succès" });
    }, 1000);
  });
};
